import Controller from '@ember/controller';

export default class AuthenticatedTeamsShowProjectsController extends Controller {}
